<template>
  <k-page class="page-settings">
    <the-lng-settings />
  </k-page>
</template>

<script>
/**
 * Component: page-settings - Страница настроек
*
* @version 1.0.0
*/


// Components
import TheLngSettings from '@/components/TheLngSettings.vue';
import KPage from '@/components/KPage.vue';


export default {
  name: 'page-settings',

  components: {
    KPage,
    TheLngSettings,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-settings {
  $this: &;
}
</style>
